import { render, staticRenderFns } from "./AsideTitle.vue?vue&type=template&id=67a88bfc&scoped=true&"
import script from "./AsideTitle.vue?vue&type=script&lang=js&"
export * from "./AsideTitle.vue?vue&type=script&lang=js&"
import style0 from "./AsideTitle.vue?vue&type=style&index=0&id=67a88bfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a88bfc",
  null
  
)

export default component.exports